export const TOTAL_QUESTIONS = 19;
export const MAX_QUESTION_INDEX = TOTAL_QUESTIONS-1;

export function mapQuestionIndexToPercentage(index) {
    if(index >=0 && index < TOTAL_QUESTIONS) {
        if(index === MAX_QUESTION_INDEX)
            return 1;
        return 90 - 5*index;
    }
}

export function mapEnumValueToDisplayable(value) {
    switch(value) {
        case "NOT_ANSWERED": return "-";
        case "RIGHT": return "✔";
        case "WRONG": return "✘";
        case "JOKER": return "★";
        default: return value;
    }
}

export function getBestCorrectAnswerIndex(answers) {
    return answers.findIndex((a) => a === "WRONG");
}

